module.exports = __webpack_public_path__ + "static/media/ico_view.f00d8342.svg";